import React, { useState, useEffect } from "react";
import { Button, Form, Input } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";

function Register02({ registeredMobile, smsExpiresAt, resend }) {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [secondsToEnd, setSecondsToEnd] = useState(smsExpiresAt);

  const REGISTER02 = gql`
    mutation Register02($authRegister2Input: AuthRegister2Input!) {
      authRegister2(authRegister2Input: $authRegister2Input) {
        accessToken
        expiresAt
        refreshToken
      }
    }
  `;

  const [runRegister02, register02] = useMutation(REGISTER02, {
    onCompleted(data) {
      const userRole = data?.authRegister2?.userRole;
      localStorage.setItem("accessToken", data?.authRegister2.accessToken);
      localStorage.setItem("expiresAt", data?.authRegister2.expiresAt);
      localStorage.setItem("refreshToken", data?.authRegister2.refreshToken);
      localStorage.setItem("role", data?.authRegister2?.userRole);
      userRole === "ADMIN" ? navigate("/admin-users") : navigate("/dashboard");
    },
    onError(error) {
      setError(error.message);
    },
  });
  useEffect(() => {
    let x = setTimeout(() => {
      setSecondsToEnd(secondsToEnd - 1);
    }, 1000);
    if (secondsToEnd === 0) {
      return () => clearTimeout(x);
    }
  }, [secondsToEnd]);
  function doRegister02(authRegister2Input) {
    authRegister2Input.mobile = registeredMobile;
    runRegister02({
      variables: {
        authRegister2Input,
      },
    });
  }

  if (!secondsToEnd) resend();

  return (
    <div>
      <Form name="normal_login" className="login-form" onFinish={doRegister02}>
        <Form.Item
          style={{ marginBottom: "30px" }}
          name="registerOtp"
          rules={[
            {
              required: true,
              message: "لطفا کد ارسال شده را وارد کنید!",
            },
            {
              pattern: /^[0-9]{5}$/,
              message: "فرمت صحیح نیست!",
            },
          ]}
          help={error}
        >
          <Input
            size="large"
            className="form-input"
            prefix={<MessageOutlined className="site-form-item-icon" />}
            placeholder=" کد یکبار مصرف "
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            className="login-form-button"
             style={{
              width:"50%",
              display:'block',
              margin:'auto',
              height: '40px'
            }}
            htmlType="submit"
            loading={register02.loading && true}
            disabled={!secondsToEnd}
          >
            ثبت نام <span style={{ width: "25px" }}>{secondsToEnd}</span>
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default Register02;
